import { IS_LOCAL_STORAGE } from '../../constants.js';

const UI_COMPONENTS_URL_KEY = 'base.ui.components.url';
const LOCAL_STORAGE_OVERRIDE = IS_LOCAL_STORAGE && localStorage.getItem(UI_COMPONENTS_URL_KEY);
const JS_FILE_PATH = 'dist/umd/index.js';
const WEB_COMPONENTS_UI_LIB_NAME = '@descope/web-components-ui';

export { JS_FILE_PATH, LOCAL_STORAGE_OVERRIDE, UI_COMPONENTS_URL_KEY, WEB_COMPONENTS_UI_LIB_NAME };
//# sourceMappingURL=constants.js.map
